import axios from "axios";

/**
 * Returns the counts for admin dashboard quick view
 * @returns Object
 */
export function getDashboardCounts() {
  return axios.get(process.env.REACT_APP_API + "/admin/dashboard/counts").then((response) => response.data);
}
